<template>
    <div>
        <el-row class="search-add" :gutter="15">
            <el-col :span="10">
                <el-input placeholder="角色名称" v-model="name"></el-input>
            </el-col>
            <el-col :span="11">
                <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
            </el-col>
            <el-col :span="2">
                <router-link to="./add">
                    <el-button type="success">新增</el-button>
                </router-link>
            </el-col>
        </el-row>

        <el-table :data="data" border stripe style="width: 100%">
            <el-table-column prop="id" label="ID">
            </el-table-column>
            <el-table-column prop="name" label="角色名">
            </el-table-column>
            <el-table-column prop="roleNo" label="角色编号">
            </el-table-column>
            <el-table-column prop="desc" label="描述">
            </el-table-column>
            <el-table-column prop="createTime" label="创建时间">
            </el-table-column>
            <el-table-column fixed="right" label="操作" width="150">
                <template slot-scope="scope">
                    <el-button @click="Edit(scope.row)" type="text" size="small">编辑</el-button>
                    <el-button @click="Delete(scope.$index)" type="text" size="small">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="tableDel-Page">
            <Pagination :params="pagin" @pageBind="getList"></Pagination>
        </div>
    </div>
</template>

<script>
    import Pagination from '@/components/Pagination';
    export default {
        data() {
            return {
                name: '',//搜索框
                data: [],
                pagin: {
                    pageNum: 1,
                    pageSize: 20,
                    total: 0,
                },
                checkArray:[]//check选中
            }
        },
        methods: {
            search() {//搜索
                this.pagin.pageNum = 1;
                this.getList();
            },
            getList() {
                //数据绑定
                let params = {
                    pageNum: this.pagin.pageNum,
                    pageSize: this.pagin.pageSize,
                }
                if (this.name.trim() != '') {
                    params.name = this.name;
                }
                this.$http.post('/manage/role/list', params).then(results => {
                    this.data = results['data']['data']['records'];
                    this.pagin.total = results['data']['data']['total'];
                });
            },
            Delete(index) {
                //单删
                if(confirm('确认要删除吗？')) {
                    let ID = this.data[index].id;
                    let title = this.data[index].title;
                    this.$http.post('/manage/role/del',{id:ID}).then(() => {
                        this.data.splice(index, 1);
                    })
                }
            },
            Edit(row) {
                this.$store.state.roleInfo = row;
                this.$router.push('./edit/'+row.id);
            },
        },
        components: { Pagination }
    }
</script>